const bournemouth = [
  {
    id: 0,
    pais: "inglaterra",
    liga: "premier-league",
    time: "bournemouth",
    nome: "Bournemouth 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bournemouth",
      "the cherries",
      "bournemouth 2025",
      "2025 bournemouth",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/bournemouth/25-26-01/uni0.jpg",
      "/images/inglaterra/premier-league/bournemouth/25-26-01/uni1.jpg",
    ],
  },
  {
    id: 1,
    pais: "inglaterra",
    liga: "premier-league",
    time: "bournemouth",
    nome: "Bournemouth 25/26 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "bournemouth",
      "the cherries",
      "bournemouth 2025",
      "2025 bournemouth",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/bournemouth/25-26-02/uni0.jpg",
      "/images/inglaterra/premier-league/bournemouth/25-26-02/uni1.jpg",
    ],
  },
  {
    id: 2,
    pais: "inglaterra",
    liga: "premier-league",
    time: "bournemouth",
    nome: "Bournemouth 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "bournemouth",
      "the cherries",
      "bournemouth 2025",
      "2025 bournemouth",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/bournemouth/25-26-03/uni0.png",
      "/images/inglaterra/premier-league/bournemouth/25-26-03/uni1.png",
    ],
  },
  {
    id: 3,
    pais: "inglaterra",
    liga: "premier-league",
    time: "bournemouth",
    nome: "Bournemouth 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "bournemouth",
      "the cherries",
      "bournemouth 2024",
      "2024 bournemouth",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/bournemouth/24-25-01/uni0.jpg",
      "/images/inglaterra/premier-league/bournemouth/24-25-01/uni1.jpg",
      "/images/inglaterra/premier-league/bournemouth/24-25-01/uni2.jpg",
      "/images/inglaterra/premier-league/bournemouth/24-25-01/uni3.jpg",
      "/images/inglaterra/premier-league/bournemouth/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "inglaterra",
    liga: "premier-league",
    time: "bournemouth",
    nome: "Bournemouth 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "bournemouth",
      "the cherries",
      "bournemouth 2024",
      "2024 bournemouth",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/bournemouth/24-25-02/uni0.png",
      "/images/inglaterra/premier-league/bournemouth/24-25-02/uni1.png",
    ],
  },
  {
    id: 5,
    pais: "inglaterra",
    liga: "premier-league",
    time: "bournemouth",
    nome: "Bournemouth 24/25 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "bournemouth",
      "the cherries",
      "bournemouth 2024",
      "2024 bournemouth",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/bournemouth/24-25-03/uni0.png",
      "/images/inglaterra/premier-league/bournemouth/24-25-03/uni1.png",
    ],
  },
  {
    id: 6,
    pais: "inglaterra",
    liga: "premier-league",
    time: "bournemouth",
    nome: "Bournemouth 24/25 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "bournemouth",
      "the cherries",
      "bournemouth 2024",
      "2024 bournemouth",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/bournemouth/24-25-00-es/uni0.jpg",
      "/images/inglaterra/premier-league/bournemouth/24-25-00-es/uni1.jpg",
      "/images/inglaterra/premier-league/bournemouth/24-25-00-es/uni2.jpg",
      "/images/inglaterra/premier-league/bournemouth/24-25-00-es/uni3.jpg",
    ],
  },
  {
    id: 7,
    pais: "inglaterra",
    liga: "premier-league",
    time: "bournemouth",
    nome: "Bournemouth 24/25 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "bournemouth",
      "the cherries",
      "bournemouth 2024",
      "2024 bournemouth",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/bournemouth/24-25-00-es1/uni0.jpg",
      "/images/inglaterra/premier-league/bournemouth/24-25-00-es1/uni1.jpg",
      "/images/inglaterra/premier-league/bournemouth/24-25-00-es1/uni2.jpg",
      "/images/inglaterra/premier-league/bournemouth/24-25-00-es1/uni3.jpg",
      "/images/inglaterra/premier-league/bournemouth/24-25-00-es1/uni4.jpg",
    ],
  },
];

export default bournemouth;
